
import { NavController, NavParams, PopoverController, Platform, Events, LoadingController, ToastController } from 'ionic-angular';
import { Component, ViewChild, ElementRef } from '@angular/core';
import { CustomLineComponent } from '../../../components/custom-line/custom-line';
import { PatientService } from '../../../services/patient.service';
import { Constants } from '../../../constants';
import domtoimage from "dom-to-image-more";
import { Medicion, MedicionApi } from '../../../services/lbsdk';
import { FichaDataPacientPage } from '../ficha-data-pacient/ficha-data-pacient';
import { FichaTabsPage } from '../ficha-tabs';
@Component({
  selector: 'page-ficha-medicion',
  templateUrl: 'ficha-medicion.html'
})
export class FichaMedicionPage {
  result: any = null;
  mmMarkers: number;
  zoom: number = 1;
  resultSuccess = true;
  @ViewChild('imagen') imagen: ElementRef;
  @ViewChild('frameTop') frameTop: CustomLineComponent;
  @ViewChild('frameBottom') frameBottom: CustomLineComponent;
  @ViewChild('noseBridge') noseBridge: CustomLineComponent;
  //VARIABLES
  image;
  imageModeloLente;
  imageReceta;
  scrollTop: number;
  scrollVariable;
  width: number;
  height: number;
  marginTop: number;
  marginLeft: number;
  maxWidth: number;
  maxHeight: number;
  deviceWidth: number;
  deviceHeight: number;
  diametro: number = 20;

  xMarkerIzq: number = -100;
  yMarkerIzq: number = -100;
  xMarkerDer: number = -100;
  yMarkerDer: number = -100;

  xPupilaIzq: number = -100;
  yPupilaIzq: number = -100;
  xPupilaDer: number = -100;
  yPupilaDer: number = -100;

  x1FrameTop: number = -100;
  y1FrameTop: number = -100;
  x2FrameTop: number = -100;
  y2FrameTop: number = -100;

  x1FrameBottom: number = -100;
  y1FrameBottom: number = -100;
  x2FrameBottom: number = -100;
  y2FrameBottom: number = -100;

  x1NoseBridge: number = -100;
  y1NoseBridge: number = -100;
  x2NoseBridge: number = -100;
  y2NoseBridge: number = -100;

  // ...
  yEndNoseBridge: number = -100;


  markerIzqSelected: boolean = false;
  markerDerSelected: boolean = false;
  pupilaIzqSelected: boolean = false;
  pupilaDerSelected: boolean = false;
  frameTopSelected: boolean = false;
  frameBottomSelected: boolean = false;
  noseBridgeSelected: boolean = false;

  nameSelected: string = null;
  point: boolean = false;
  mailer: boolean = false;

  xMarkerIzqReal: number;
  yMarkerIzqReal: number;
  xMarkerDerReal: number;
  yMarkerDerReal: number;

  xPupilaIzqReal: number;
  yPupilaIzqReal: number;
  xPupilaDerReal: number;
  yPupilaDerReal: number;

  x1FrameTopReal: number;
  y1FrameTopReal: number;
  x2FrameTopReal: number;
  y2FrameTopReal: number;

  x1FrameBottomReal: number;
  y1FrameBottomReal: number;
  x2FrameBottomReal: number;
  y2FrameBottomReal: number;

  x1NoseBridgeReal: number;
  y1NoseBridgeReal: number;
  x2NoseBridgeReal: number;
  y2NoseBridgeReal: number;


  yEndNoseBridgeReal: number;

  private ZOOM_MIN: number = .5;
  private ZOOM_MAX: number = 3;
  private ZOOM_STEP: number = .5;

  distance: number = null;
  resultPaciente;

  urlFoto: string = "";

  constructor(
    public navCtrl: NavController, public navParams: NavParams,
    platform: Platform, public patientApi: PatientService,
    public events: Events,
    private loadingCtrl: LoadingController, private toastController: ToastController,
    private medicionApi: MedicionApi

  ) {

    this.resultPaciente = navParams.data//.get('result');

    if (this.resultPaciente) {

      //   this.imageModeloLente = this.resultPaciente.recipe.framePicture;
      //   this.imageReceta = this.resultPaciente.recipe.recipePicture;
      this.mmMarkers = this.resultPaciente.result.mmMarkersDistance;

    }
    console.log("TAB MEDIOCIONES ", this.resultPaciente)

    platform.ready().then((readySource) => {

      this.deviceWidth = platform.width();
      this.deviceHeight = platform.height();
      // alert(this.deviceHeight)
      //HACK GERMAN this.mmMarkers = 10;//this.setupProvider.mmDistanceBetweenMarkers;
      this.mailer = true;// "gfernandez@r1sa.com";//this.setupProvider.email.length > 0;


    });
  }
  inRange() {
    return this.mmCameraDistance >= 200 && this.mmCameraDistance <= 500
  }
  sendMail() {
    /* this.socialSharing.share('Resultado de la medición\n' + this.getResultado(), 'Enviar a: ' + this.setupProvider.email, this.image).then((data) => {
       // Success!
       console.log(data)
     }).catch((e) => {
       // Error!
       console.log(e)
     });
 */
  }



  cambioPosicion(event) {
    //  alert("pasa " + JSON.stringify(this.scrollVariable))
    console.log('entro en cambio pos', event, this.yMarkerIzq)
    // console.log(this.scrollVariable.scrollTop + "event.position.y" + event.position.y)
    //this.scrollVariable.scrollTop
    let markerMoved: Boolean = false;
    switch (event.name) {
      case 'marker-izquierdo':
        this.xMarkerIzqReal = ((event.position.x) - this.marginLeft - this.diametro) / this.zoom;
        this.yMarkerIzqReal = ((event.position.y) - this.marginTop - this.diametro) / this.zoom;
        markerMoved = true
        break;
      case 'marker-derecho':
        this.xMarkerDerReal = ((event.position.x) - this.marginLeft - this.diametro) / this.zoom;
        this.yMarkerDerReal = ((event.position.y) - this.marginTop - this.diametro) / this.zoom;
        markerMoved = true
        break;
      case 'pupila-izquierda':

        this.xPupilaIzqReal = ((event.position.x) - this.marginLeft - this.diametro) / this.zoom;
        this.yPupilaIzqReal = ((event.position.y) - this.marginTop - this.diametro) / this.zoom;
        break;
      case 'pupila-derecha':
        this.xPupilaDerReal = ((event.position.x) - this.marginLeft - this.diametro) / this.zoom;
        this.yPupilaDerReal = ((event.position.y) - this.marginTop - this.diametro) / this.zoom;
        break;
      case 'frame-top':
        this.x1FrameTopReal = ((event.position.x1) - this.marginLeft) / this.zoom;
        this.y1FrameTopReal = ((event.position.y1) - this.marginTop) / this.zoom;
        this.x2FrameTopReal = ((event.position.x2) - this.marginLeft) / this.zoom
        this.y2FrameTopReal = ((event.position.y2) - this.marginTop) / this.zoom
        this.point = false;
        break;
      case 'frame-bottom':
        this.x1FrameBottomReal = ((event.position.x1) - this.marginLeft) / this.zoom;
        this.y1FrameBottomReal = ((event.position.y1) - this.marginTop) / this.zoom;
        this.x2FrameBottomReal = ((event.position.x2) - this.marginLeft) / this.zoom
        this.y2FrameBottomReal = ((event.position.y2) - this.marginTop) / this.zoom
        this.point = false;
        break;
      case 'nose-bridge':

        this.x1NoseBridgeReal = ((event.position.x1) - this.marginLeft) / this.zoom;
        this.y1NoseBridgeReal = ((event.position.y1) - this.marginTop) / this.zoom;
        this.x2NoseBridgeReal = ((event.position.x2) - this.marginLeft) / this.zoom
        this.y2NoseBridgeReal = ((event.position.y2) - this.marginTop) / this.zoom
        this.point = false;

        break;

    }

    if (markerMoved) {
      let middleMarkerLine = this.lineBetweenMarkers(
        { x: this.xMarkerIzqReal, y: this.yMarkerIzqReal },
        { x: this.xMarkerDerReal, y: this.yMarkerDerReal }
      );
      this.x1NoseBridgeReal = middleMarkerLine.start.x;
      this.y1NoseBridgeReal = middleMarkerLine.start.y;
      this.x2NoseBridgeReal = middleMarkerLine.end.x;
      this.y2NoseBridgeReal = middleMarkerLine.end.y;

      // 
      this.x1NoseBridge = this.x1NoseBridgeReal * this.zoom + this.marginLeft;
      this.y1NoseBridge = this.y1NoseBridgeReal * this.zoom + this.marginTop;
      this.x2NoseBridge = this.x2NoseBridgeReal * this.zoom + this.marginLeft;
      this.y2NoseBridge = this.y2NoseBridgeReal * this.zoom + this.marginTop;
    }

    this.setResult(this.calculateDistances());

  }

  mover(x, y) {

    console.log("mover: ", x, y)
    if (!this.nameSelected) return
    let event: any = {};
    event.name = this.nameSelected;
    event.position = {};

    switch (this.nameSelected) {
      case 'marker-izquierdo':
        event.position.x = 40 + (this.xMarkerIzq += x);
        event.position.y = 40 + (this.yMarkerIzq += y);
        break;
      case 'marker-derecho':
        event.position.x = 40 + (this.xMarkerDer += x);
        event.position.y = 40 + (this.yMarkerDer += y);
        break;
      case 'pupila-izquierda':
        // alert(this.xPupilaIzqReal.toString() + " " +   this.xPupilaIzq.toString());
        // console.log(this.xPupilaIzqReal.toString() + " " + this.xPupilaIzq.toString())
        event.position.x = 40 + (this.xPupilaIzq += x);
        event.position.y = 40 + (this.yPupilaIzq += y);
        break;
      case 'pupila-derecha':
        event.position.x = 40 + (this.xPupilaDer += x);
        event.position.y = 40 + (this.yPupilaDer += y);
        break;
      case 'frame-top':
        event.position.x1 = (this.x1FrameTop += x);
        event.position.y1 = (this.y1FrameTop += y);
        event.position.x2 = (this.x2FrameTop += x);
        event.position.y2 = (this.y2FrameTop += y);
        break;
      case 'frame-bottom':
        event.position.x1 = (this.x1FrameBottom += x);
        event.position.y1 = (this.y1FrameBottom += y);
        event.position.x2 = (this.x2FrameBottom += x);
        event.position.y2 = (this.y2FrameBottom += y);
        break;
      case 'nose-bridge':

        event.position.x1 = (this.x1NoseBridge += x);
        event.position.y1 = (this.y1NoseBridge += y);
        event.position.x2 = (this.x2NoseBridge += x);
        event.position.y2 = (this.y2NoseBridge += y);

        break;
    }
    this.cambioPosicion(event);
  }


  rotar(grados) {
    if (!this.nameSelected) return

    switch (this.nameSelected) {
      case 'frame-top':
        this.frameTop.rotateCounterClockwise(grados);
        break;
      case 'frame-bottom':
        this.frameBottom.rotateCounterClockwise(grados);
        break;
      case 'nose-bridge':
        this.noseBridge.rotateCounterClockwise(grados);
        break;
    }
  }



  private calculateDistances() {

    let pxMarkersDistance = Math.hypot(
      Math.abs(this.xMarkerDerReal - this.xMarkerIzqReal),
      Math.abs(this.yMarkerDerReal - this.yMarkerIzqReal));

    let pxPupilsDistance = Math.hypot(
      Math.abs(this.xPupilaDerReal - this.xPupilaIzqReal),
      Math.abs(this.yPupilaDerReal - this.yPupilaIzqReal));


    let mmPupilsDistance = this.pixelToMillimeters(pxMarkersDistance, pxPupilsDistance);

    // let vx = this.x2NoseBridgeReal - this.x1NoseBridgeReal;
    // let vy = this.y2NoseBridgeReal - this.y1NoseBridgeReal;

    let vectorNoseBridge = {
      x: this.x2NoseBridgeReal - this.x1NoseBridgeReal,
      y: this.y2NoseBridgeReal - this.y1NoseBridgeReal
    }

    let vectorLeftPupilToNoseBridge = {
      x: this.xPupilaIzqReal - this.x1NoseBridgeReal,
      y: this.yPupilaIzqReal - this.y1NoseBridgeReal
    }

    let vectorRightPupilToNoseBridge = {
      x: this.xPupilaDerReal - this.x1NoseBridgeReal,
      y: this.yPupilaDerReal - this.y1NoseBridgeReal
    }

    let pxLeftPupilToBridge = this.distanceToVector(vectorLeftPupilToNoseBridge, vectorNoseBridge);
    let pxRightPupilToBridge = this.distanceToVector(vectorRightPupilToNoseBridge, vectorNoseBridge);

    //let [pxLeftPupilToBridge, pxRightPupilToBridge] = this.pxPupilsDistanceToBridge();

    let mmLeftPupilToBridge = this.pixelToMillimeters(pxMarkersDistance, pxLeftPupilToBridge);
    let mmRightPupilToBridge = this.pixelToMillimeters(pxMarkersDistance, pxRightPupilToBridge);

    let [pxLeftPupilToFrameTop, pxLeftPupilToFrameBottom] = this.pxPupilDistanceToFrame(this.xPupilaIzqReal, this.yPupilaIzqReal);

    let [pxRightPupilToFrameTop, pxRightPupilToFrameBottom] = this.pxPupilDistanceToFrame(this.xPupilaDerReal, this.yPupilaDerReal);

    let mmLeftPupilToFrameTop = this.pixelToMillimeters(pxMarkersDistance, pxLeftPupilToFrameTop);
    let mmLeftPupilToFrameBottom = this.pixelToMillimeters(pxMarkersDistance, pxLeftPupilToFrameBottom);
    let mmRightPupilToFrameTop = this.pixelToMillimeters(pxMarkersDistance, pxRightPupilToFrameTop);
    let mmRightPupilToFrameBottom = this.pixelToMillimeters(pxMarkersDistance, pxRightPupilToFrameBottom);

    let middleMarkerLine = this.lineBetweenMarkers(
      { x: this.xMarkerIzqReal, y: this.yMarkerIzqReal },
      { x: this.xMarkerDerReal, y: this.yMarkerDerReal }
    );


    let res =
    {
      mmPupilsDistance: mmPupilsDistance,
      mmLeftPupilToBridge: mmLeftPupilToBridge,
      mmRightPupilToBridge: mmRightPupilToBridge,
      mmLeftPupilToFrameTop: mmLeftPupilToFrameTop,
      mmLeftPupilToFrameBottom: mmLeftPupilToFrameBottom,
      mmRightPupilToFrameTop: mmRightPupilToFrameTop,
      mmRightPupilToFrameBottom: mmRightPupilToFrameBottom,
      middleMarkerLine: middleMarkerLine,
      //revisar
      pxMarkersDistance: pxMarkersDistance,
      pxPupilsDistance: pxPupilsDistance,
      pxLeftPupilToBridge: pxLeftPupilToBridge,
      pxRightPupilToBridge: pxRightPupilToBridge,
      pxLeftPupilToFrameTop: pxLeftPupilToFrameTop,
      pxLeftPupilToFrameBottom: pxLeftPupilToFrameBottom,
      pxRightPupilToFrameTop: pxRightPupilToFrameTop,
      pxRightPupilToFrameBottom: pxRightPupilToFrameBottom


    };

    return res;

  }


  private pxPupilDistanceToFrame(pupilX, pupilY) {

    let vectorTopFrame = {
      x: this.x2FrameTopReal - this.x1FrameTopReal,
      y: this.y2FrameTopReal - this.y1FrameTopReal
    }
    let vectorTopLeftPupil = {
      x: pupilX - this.x1FrameTopReal,
      y: pupilY - this.y1FrameTopReal
    }

    let pxDistanceToTopFrame = this.distanceToVector(vectorTopLeftPupil, vectorTopFrame);

    let vectorBottomFrame = {
      x: this.x2FrameBottomReal - this.x1FrameBottomReal,
      y: this.y2FrameBottomReal - this.y1FrameBottomReal
    }
    let vectorBottomLeftPupil = {
      x: pupilX - this.x1FrameBottomReal,
      y: pupilY - this.y1FrameBottomReal
    }
    let pxDistanceToBottomFrame = this.distanceToVector(vectorBottomLeftPupil, vectorBottomFrame);

    return [pxDistanceToTopFrame, pxDistanceToBottomFrame];
  }



  private distanceToVector(w, v) {

    let radians = -Math.atan2(v.y, v.x);
    // rotate vx,vy && qx, qy ; -radians
    let rv_y = v.x * Math.sin(radians) + v.y * Math.cos(radians);
    let rw_y = w.x * Math.sin(radians) + w.y * Math.cos(radians);

    return Math.abs(rw_y - rv_y);
  }



  private pixelToMillimeters(pxMarkersDistance, pxDistanceToConvert) {
    let ratio = pxMarkersDistance / pxDistanceToConvert;
    return this.mmMarkers / ratio;
  }


  private lineBetweenMarkers(positionMarker1, positionMarker2) {
    // vector from marker1 to marker2, divido 2 (middle point)
    let v = {
      x: (positionMarker2.x - positionMarker1.x) / 2,
      y: (positionMarker2.y - positionMarker1.y) / 2,
    };

    // vector perpendicular
    let wv = {
      x: -v.y,
      y: v.x
    }

    let distance = this.yEndNoseBridgeReal - v.y - positionMarker1.y;
    this.scaleNoseBridgeVector(wv, distance);

    wv.x += v.x + positionMarker1.x;
    wv.y += v.y + positionMarker1.y;
    v.x += positionMarker1.x;
    v.y += positionMarker1.y;
    // wv.x += positionMarker1.x;
    // wv.y += positionMarker1.y;

    return {
      start: v,
      end: wv
    }
  }

  private scaleNoseBridgeVector(v, vLength) {
    length = Math.sqrt(v.x * v.x + v.y * v.y);
    v.x /= length;
    v.y /= length;
    let scaleFactor = vLength / v.y;
    v.x *= scaleFactor;
    v.y *= scaleFactor;
  }


  cambioSeleccionado(name) {
    console.log("CAMBIO SELECCIONADO", name)
    this.nameSelected = name;
    this.point = true;
    this.markerIzqSelected = false;
    this.markerDerSelected = false;
    this.pupilaIzqSelected = false;
    this.pupilaDerSelected = false;
    this.frameTopSelected = false;
    this.frameBottomSelected = false;
    this.noseBridgeSelected = false;
    //this.middleMarkerSelected = false;
    switch (name) {
      case 'marker-izquierdo':
        this.markerIzqSelected = true;
        break;
      case 'marker-derecho':
        this.markerDerSelected = true;
        break;
      case 'pupila-izquierda':
        this.pupilaIzqSelected = true;
        break;
      case 'pupila-derecha':
        this.pupilaDerSelected = true;
        break;
      case 'frame-top':
        this.frameTopSelected = true;
        this.point = false;
        break;
      case 'frame-bottom':
        this.frameBottomSelected = true;
        this.point = false;
        break;
      case 'nose-bridge':
        this.noseBridgeSelected = true;
        this.point = false;
        break;
    }

  }

  resizeImage(zoom: number = 1) {

    this.width = this.imagen.nativeElement.naturalWidth * zoom;
    this.height = this.imagen.nativeElement.naturalHeight * zoom;
    this.marginTop = 0//(this.deviceHeight - this.height) / 2;
    this.marginLeft = (this.deviceWidth - this.width) / 2;
    this.maxWidth = this.width;
    this.maxHeight = this.height;

    this.xMarkerIzq = this.xMarkerIzqReal * this.zoom + this.marginLeft - this.diametro;
    this.yMarkerIzq = this.yMarkerIzqReal * this.zoom + this.marginTop - this.diametro;
    this.xMarkerDer = this.xMarkerDerReal * this.zoom + this.marginLeft - this.diametro;
    this.yMarkerDer = this.yMarkerDerReal * this.zoom + this.marginTop - this.diametro;

    this.xPupilaIzq = this.xPupilaIzqReal * this.zoom + this.marginLeft - this.diametro;
    this.yPupilaIzq = this.yPupilaIzqReal * this.zoom + this.marginTop - this.diametro;
    this.xPupilaDer = this.xPupilaDerReal * this.zoom + this.marginLeft - this.diametro;
    this.yPupilaDer = this.yPupilaDerReal * this.zoom + this.marginTop - this.diametro;

    this.x1FrameTop = this.x1FrameTopReal * this.zoom + this.marginLeft;
    this.y1FrameTop = this.y1FrameTopReal * this.zoom + this.marginTop;
    this.x2FrameTop = this.x2FrameTopReal * this.zoom + this.marginLeft;
    this.y2FrameTop = this.y2FrameTopReal * this.zoom + this.marginTop;

    this.x1FrameBottom = this.x1FrameBottomReal * this.zoom + this.marginLeft;
    this.y1FrameBottom = this.y1FrameBottomReal * this.zoom + this.marginTop;
    this.x2FrameBottom = this.x2FrameBottomReal * this.zoom + this.marginLeft;
    this.y2FrameBottom = this.y2FrameBottomReal * this.zoom + this.marginTop;

    this.x1NoseBridge = this.x1NoseBridgeReal * this.zoom + this.marginLeft;
    this.y1NoseBridge = this.y1NoseBridgeReal * this.zoom + this.marginTop;
    this.x2NoseBridge = this.x2NoseBridgeReal * this.zoom + this.marginLeft;
    this.y2NoseBridge = this.y2NoseBridgeReal * this.zoom + this.marginTop;

    this.yEndNoseBridge = this.yEndNoseBridgeReal * this.zoom + this.marginTop;


    this.printImageSize();



  }
  ngAfterViewInit() {
    this.imagen.nativeElement.addEventListener('load', () => {
      console.log('load')
      this.resizeImage(this.zoom);
    });
  }
  printImageSize() {
    console.log('device: ', this.deviceWidth, this.deviceHeight)
    console.log('Image width is: ', this.imagen.nativeElement.naturalWidth);
    console.log('Image height is: ', this.imagen.nativeElement.naturalHeight);
    console.log('this.marginTop ', this.marginTop);
    console.log('this.marginLeft ', this.marginLeft);
    console.log('w ', this.width);
    console.log('h ', this.height);
    console.log('marker izq:', this.xMarkerIzq, this.yMarkerIzq)
    console.log('marker izq real:', this.xMarkerIzqReal, this.yMarkerIzqReal)
  }

  // zoomChange() {
  //   console.log('zoom')
  //   this.zoom += .5;
  //   if (this.zoom > 2) this.zoom = .5;
  //   this.resizeImage(this.zoom);
  // }

  zoomOut() {
    console.log('zoom Out')
    if (this.zoom == this.ZOOM_MIN) return
    this.zoom -= this.ZOOM_STEP;
    this.resizeImage(this.zoom);
  }

  zoomIn() {
    console.log('zoom In')
    if (this.zoom == this.ZOOM_MAX) return
    this.zoom += this.ZOOM_STEP;
    this.resizeImage(this.zoom);
  }

  toMilimeters(distancia: number): string {
    let res: string;
    try {
      res = (distancia).toFixed(2)//`${(distancia).toFixed(2)} mm`;
    } catch (e) {
      res = (0).toFixed(2)// `${(0).toFixed(2)} mm`;
    }
    return res;
    // return `${(
    //   (pxFrom * this.mmMarkers) /
    //   this.result.pxMarkersDistance
    // ).toFixed(2)} mm`;
  }


  mmCameraDistance: number = 0;
  //ionViewDidLoad() {
  ionViewDidLoad() {

    //let result = this.n avParams.get('result');
    this.resultPaciente = this.navParams.data//.get('result');
    console.log("DATOS ", this.resultPaciente)

    //this.image = this.resultPaciente.image;//result.image;
    this.image = Constants.urlFotos + this.resultPaciente.idMedicion + '/download/foto.jpeg'

    this.resultPaciente.success = true;

    if (this.resultPaciente.success) {

      this.mmCameraDistance = this.resultPaciente.result.mmCameraDistance;
      //  alert(JSON.stringify(this.resultPaciente.frame.bot));
      this.xMarkerIzqReal = this.resultPaciente.result.markers.left[0];//result.data.markers.left[0];
      this.yMarkerIzqReal = this.resultPaciente.result.markers.left[1]; //result.data.markers.left[1];
      this.xMarkerDerReal = this.resultPaciente.result.markers.right[0]; //result.data.markers.right[0];
      this.yMarkerDerReal = this.resultPaciente.result.markers.right[1];// result.data.markers.right[1];

      this.xPupilaIzqReal = this.resultPaciente.result.pupils.left[0];//result.data.pupils.left[0];
      this.yPupilaIzqReal = this.resultPaciente.result.pupils.left[1];//result.data.pupils.left[1];
      this.xPupilaDerReal = this.resultPaciente.result.pupils.right[0];// result.data.pupils.right[0];
      this.yPupilaDerReal = this.resultPaciente.result.pupils.right[1];//result.data.pupils.right[1];

      this.x1FrameTopReal = this.resultPaciente.result.frame.top.left[0];//result.data.frame.top.left[0];
      this.y1FrameTopReal = this.resultPaciente.result.frame.top.left[1];
      this.x2FrameTopReal = this.resultPaciente.result.frame.top.right[0];
      this.y2FrameTopReal = this.resultPaciente.result.frame.top.right[1];

      this.x1FrameBottomReal = this.resultPaciente.result.frame.bot.left[0];
      this.y1FrameBottomReal = this.resultPaciente.result.frame.bot.left[1];
      this.x2FrameBottomReal = this.resultPaciente.result.frame.bot.right[0];
      this.y2FrameBottomReal = this.resultPaciente.result.frame.bot.right[1];

      this.yEndNoseBridgeReal = this.resultPaciente.result.noseBridge.bot[1];

      let middleMarkerLine = this.lineBetweenMarkers(
        { x: this.xMarkerIzqReal, y: this.yMarkerIzqReal },
        { x: this.xMarkerDerReal, y: this.yMarkerDerReal }
      );


      this.x1NoseBridgeReal = middleMarkerLine.start.x;
      this.y1NoseBridgeReal = middleMarkerLine.start.y;
      this.x2NoseBridgeReal = middleMarkerLine.end.x;
      this.y2NoseBridgeReal = middleMarkerLine.end.y;

      //   alert(result.data.mmCameraDistance);
      //  this.mmCameraDistance = 409.756097560976;//result.data.mmCameraDistance;
      this.setResult(this.calculateDistances())
    } else {
      setTimeout(() => {
        this.navCtrl.pop();
      }, 3000);
    }
  }

  resultData: any;
  setResult(data) {

    //this.resultData = data;
    //  this.resultData.mmCameraDistance = this.mmCameraDistance
    //  this.result = {};
    this.result = data;
    this.result.mmMarkersDistance = data.mmMarkersDistance;
    //  this.mmMarkers = data.mmMarkersDistance; //HACK GERMAN
    this.result.mmCameraDistance = this.toMilimeters(
      this.mmCameraDistance
    );

    this.result.mmLeftPupilToBot = this.toMilimeters(
      data.mmLeftPupilToFrameBottom
    );

    this.result.mmLeftPupilToNose = this.toMilimeters(
      data.mmLeftPupilToBridge
    );
    this.result.mmLeftPupilToTop = this.toMilimeters(
      data.mmLeftPupilToFrameTop
    );

    this.result.mmRightPupilToBot = this.toMilimeters(
      data.mmRightPupilToFrameBottom
    );
    this.result.mmRightPupilToNose = this.toMilimeters(
      data.mmRightPupilToBridge
    );
    this.result.mmRightPupilToTop = this.toMilimeters(
      data.mmRightPupilToFrameTop
    );

    this.result.mmPupilsDistance = this.toMilimeters(
      data.mmPupilsDistance
    );


  }
  getResultado() {
    return `
      Pupila derecha al:
      puente: ${this.result.mmLeftPupilToNose}
      marco superior: ${this.result.mmLeftPupilToTop}
      marco inferior: ${this.result.mmLeftPupilToBot}
      Pupila izquierda al:
      puente: ${this.result.mmRightPupilToNose}
      marco superior: ${this.result.mmRightPupilToTop}
      marco inferior: ${this.result.mmRightPupilToBot}
      Entre pupilas: ${this.result.mmPupilsDistance}
      Cámara a ${this.result.mmCameraDistance}
      `
  }

  moreInfo() {
    this.setResult(this.calculateDistances())

    /*   this.yEndNoseBridgeReal = this.resultPaciente.result.noseBridge.bot[1];
   
       let middleMarkerLine = this.lineBetweenMarkers(
         { x: this.xMarkerIzqReal, y: this.yMarkerIzqReal },
         { x: this.xMarkerDerReal, y: this.yMarkerDerReal }
       );
       console.log("middleMarkerLine: ", middleMarkerLine);
   
       this.x1NoseBridgeReal = middleMarkerLine.start.x;
       this.y1NoseBridgeReal = middleMarkerLine.start.y;
       this.x2NoseBridgeReal = middleMarkerLine.end.x;
       this.y2NoseBridgeReal = middleMarkerLine.end.y;*/
    //   this.clientDataProvider.pictureFinal = this.image;
    //   this.clientDataProvider.result = this.resultData;
    //  this.navCtrl.push(ClientDataPage)
  }

  async actualizarMedicion() {
    await this.setResult(this.calculateDistances())
    // alert(JSON.stringify(this.result))

    let middleMarkerLine = this.lineBetweenMarkers(
      { x: this.xMarkerIzqReal, y: this.yMarkerIzqReal },
      { x: this.xMarkerDerReal, y: this.yMarkerDerReal }
    );


    this.x1NoseBridgeReal = middleMarkerLine.start.x;
    this.y1NoseBridgeReal = middleMarkerLine.start.y;
    this.x2NoseBridgeReal = middleMarkerLine.end.x;
    this.y2NoseBridgeReal = middleMarkerLine.end.y;


    let data = {
      markers: {
        left: [
          this.xMarkerIzqReal,
          this.yMarkerIzqReal
        ],
        right: [
          this.xMarkerDerReal,
          this.yMarkerDerReal
        ]
      },
      pupils: {
        left: [
          this.xPupilaIzqReal,
          this.yPupilaIzqReal
        ],
        right: [
          this.xPupilaDerReal,
          this.yPupilaDerReal
        ]
      },
      frame: {
        top: {
          left: [
            this.x1FrameTopReal,
            this.y1FrameTopReal
          ],
          right: [
            this.x2FrameTopReal,
            this.y2FrameTopReal
          ]
        },
        bot: {
          left: [
            this.x1FrameBottomReal,
            this.y1FrameBottomReal
          ],
          right: [
            this.x2FrameBottomReal,
            this.y2FrameBottomReal
          ]
        }
      },
      noseBridge: {
        top: [
          this.x1NoseBridgeReal,
          this.y1NoseBridgeReal
        ],
        bot: [
          this.x1NoseBridgeReal,
          this.y2NoseBridgeReal
        ]
      },
      mmCameraDistance: this.resultPaciente.result.mmCameraDistance,
      pxMarkersDistance: this.result.pxMarkersDistance,// 204.0,
      pxPupilsDistance: this.result.pxPupilsDistance,//182.0,
      pxLeftPupilToBridge: this.result.pxLeftPupilToBridge,//84.0,
      pxRightPupilToBridge: this.result.pxRightPupilToBridge,// 96.0,
      pxLeftPupilToTopFrame: this.result.pxLeftPupilToFrameTop,// 52.0,
      pxLeftPupilToBotFrame: this.result.pxLeftPupilToFrameBottom,//50.0,
      pxRightPupilToTopFrame: this.result.pxRightPupilToFrameTop,//52.0,
      pxRightPupilToBotFrame: this.result.pxRightPupilToFrameBottom,
      mmTotalPupilDistance: this.result.mmPupilsDistance,//58.4362745098039,
      mmMarkersDistance: 65.5,
      mmPupilsDistance: this.result.mmPupilsDistance,
      mmLeftPupilToBridge: this.result.mmLeftPupilToNose,
      mmRightPupilToBridge: this.result.mmRightPupilToNose,
      mmLeftPupilToTopFrame: this.result.mmLeftPupilToTop,
      mmLeftPupilToBotFrame: this.result.mmLeftPupilToBot,
      mmRightPupilToTopFrame: this.result.mmRightPupilToTop,
      mmRightPupilToBotFrame: this.result.mmRightPupilToBot


      /* pxLeftPupilToFrameTop: pxLeftPupilToFrameTop,
       pxLeftPupilToFrameBottom: pxLeftPupilToFrameBottom,
       pxRightPupilToFrameTop: pxRightPupilToFrameTop,
       pxRightPupilToFrameBottom: pxRightPupilToFrameBottom*/
    }
    let loader = this.loadingCtrl.create({
      content: 'Procesando...'
    });
    loader.present()
    let datosSql = this.convertirJsonMongoSql(data)
    console.log(datosSql)
    this.medicionApi.patchAttributes(this.resultPaciente.idMedicion, datosSql)
      .subscribe(res => {
        loader.dismiss();
        // this.events.publish("medicion:save");
        this.presentToast("Las mediciones fueron guardadas correctamente.")
        // this.events.publish('medicion:save', { idmedicion: this.resultPaciente.idMedicion });
        //   setTimeout(() => {
        this.navCtrl.parent.select(0);
        //this.navCtrl.setRoot(FichaDataPacientPage)

        //   }, 4000
        //  )

      }, error => {
        loader.dismiss();
        this.presentToast("Ocurrió un error al guardar las mediciones. Detalle: " + error.message)
      })
  }
  async actualizarPaciente() {
    const loader = this.loadingCtrl.create({
      content: 'Procesando mediciones e imagen...', duration: 2000
    });
    await loader.present();

    const node = document.getElementById('frenteDiv');

    try {
      const dataUrl = await domtoimage.toJpeg(node, { quality: 0.5, worker: true });

      const data = {
        id: this.resultPaciente.idMedicion,
        medicion: dataUrl
      };

      this.medicionApi.AddImagenMedicion(data).subscribe(
        respuesta => {
          console.log('Imagen asociada exitosamente');
          this.actualizarMedicion();
        },
        error => {
          console.error('Error al descargar imagen:', error);
          this.actualizarMedicion();
        },
        () => loader.dismiss()
      );
    } catch (error) {
      console.error('Error al procesar la imagen:', error);
      this.actualizarMedicion();
      loader.dismiss();
    }
  }

  /*async actualizarPaciente() {
    
    let url;
    let loader = this.loadingCtrl.create({
      content: 'Procesando mediciones e imagen...', duration: 2000
    });
    loader.present();
    var node = document.getElementById('frenteDiv');
    
    // var nodo2 = node.cloneNode(true);
    // console.log(nodo2)
    try {


      setTimeout(() => {
        domtoimage.toJpeg(node, { quality: 0.5 ,worker:true}).then((dataUrl) => {

          let data = {
            id: this.resultPaciente.idMedicion,
            medicion: dataUrl
          }
          this.medicionApi.AddImagenMedicion(data)
            .subscribe(respues => {

              console.log('ASOCIO IMAGEN ')
              loader.dismiss();
              this.actualizarMedicion();
              // return true
            })
        }, error => {
          loader.dismiss();
          this.actualizarMedicion();
          console.error('*****ERROR AL DESCARGAR IMAGEN*****DESCARGAR IMAGEN*****!', error);
          // return false;
        })

      },
        2000);
    } catch (error) {
      loader.dismiss();
      this.actualizarMedicion();
    }
  }*/

  async descargarImagen(tipo) {

    let url;
    var node = document.getElementById('frenteDiv');
    // var nodo2 = node.cloneNode(true);
    // console.log(nodo2)
    setTimeout(() => {
      domtoimage.toJpeg(node, { quality: 0.5 }).then((dataUrl) => {

        let data = {
          id: this.resultPaciente.idMedicion,
          medicion: dataUrl
        }
        this.medicionApi.AddImagenMedicion(data)
          .subscribe(respues => {

            console.log('ASOCIO IMAGEN ')
            return true
          })
      }, error => {

        console.error('*****ERROR AL DESCARGAR IMAGEN*****DESCARGAR IMAGEN*****!', error);
        return false;
      })

    },
      1500);
  }
  //MUESTRA MENSAJE
  presentToast(msg) {
    let toast = this.toastController.create({
      message: msg,
      duration: 3000,
      position: 'top'
    });

    toast.onDidDismiss(() => {
      console.log('Dismissed toast');
    });

    toast.present();
  }

  logScrollStart() {

  }

  logScrolling($event) {
    this.scrollVariable = $event
    console.log($event)

  }
  logScrollEnd($event) {
    console.log("Seteo Top")
    this.scrollVariable = $event //AGREGADO 21092023

    this.scrollTop = this.scrollVariable.scrollTop;
    console.log("VALOR SCROLLTOP ", this.scrollTop)

  }

  convertirJsonMongoSql(res) {
    let data = {
      /* company: res.company,
       emailcompany: res.emailCompany,
       name: res.name,
       lastname: res.lastname,
       number: res.number,*/
      resultmarkersleft1: res.markers.left[0],
      resultmarkersleft2: res.markers.left[1],
      resultmarkersright1: res.markers.right[0],
      resultmarkersright2: res.markers.right[1],
      resultpupilsleft1: res.pupils.left[0],
      resultpupilsleft2: res.pupils.left[1],
      resultpupilsright1: res.pupils.right[0],
      resultpupilsright2: res.pupils.right[1],
      resultframetopleft1: res.frame.top.left[0],
      resultframetopleft2: res.frame.top.left[1],
      resultframetopright1: res.frame.top.right[0],
      resultframetopright2: res.frame.top.right[1],
      resultframebotleft1: res.frame.bot.left[0],
      resultframebotleft2: res.frame.bot.left[1],
      resultframebotright1: res.frame.bot.right[0],
      resultframebotright2: res.frame.bot.right[1],
      resultnosebridgetop1: res.noseBridge.top[0],
      resultnosebridgetop2: res.noseBridge.top[1],
      resultnosebridgebot1: res.noseBridge.bot[0],
      resultnosebridgebot2: res.noseBridge.bot[1],
      resultmmcameradistance: res.mmCameraDistance == undefined ? 0 : res.mmCameraDistance,
      resultpxmarkersdistance: res.pxMarkersDistance == undefined ? 0 : res.pxMarkersDistance,
      resultpxpupilsdistance: res.pxPupilsDistance == undefined ? 0 : res.pxPupilsDistance,
      resultpxleftpupiltobridge: res.pxLeftPupilToBridge == undefined ? 0 : res.pxLeftPupilToBridge,
      resultpxrightpupiltobridge: res.pxRightPupilToBridge == undefined ? 0 : res.pxRightPupilToBridge,
      resultpxleftpupiltotopframe: res.pxLeftPupilToTopFrame == undefined ? 0 : res.pxLeftPupilToTopFrame,
      resultpxleftpupiltobotframe: res.pxLeftPupilToBotFrame == undefined ? 0 : res.pxLeftPupilToBotFrame,
      resultpxrightpupiltotopframe: res.pxRightPupilToTopFrame == undefined ? 0 : res.pxRightPupilToTopFrame,
      resultpxrightpupiltobotframe: res.pxRightPupilToBotFrame == undefined ? 0 : res.pxRightPupilToBotFrame,
      resultmmtotalpupildistance: res.mmTotalPupilDistance == undefined ? 0 : res.mmTotalPupilDistance,
      resultmmmarkersdistance: res.mmMarkersDistance == undefined ? 0 : res.mmMarkersDistance,
      resultmmpupilsdistance: res.mmPupilsDistance == undefined ? 0 : res.mmPupilsDistance,
      resultmmleftpupiltobridge: res.mmLeftPupilToBridge == undefined || res.mmLeftPupilToBridge == 'NaN' ? 0 : res.mmLeftPupilToBridge,
      resultmmrightpupiltobridge: res.mmRightPupilToBridge == undefined || res.mmRightPupilToBridge == 'NaN' ? 0 : res.mmRightPupilToBridge,
      resultmmleftpupiltotopframe: res.mmLeftPupilToTopFrame == undefined ? 0 : res.mmLeftPupilToTopFrame,
      resultmmleftpupiltobotframe: res.mmLeftPupilToBotFrame == undefined ? 0 : res.mmLeftPupilToBotFrame,
      resultmmrightpupiltotopframe: res.mmRightPupilToTopFrame == undefined ? 0 : res.mmRightPupilToTopFrame,
      resultmmrightpupiltobotframe: res.mmRightPupilToBotFrame == undefined ? 0 : res.mmRightPupilToBotFrame,
      created: res.created/*,
      idestado: res.state == undefined ? 5 : res.state,
      idsucursalmongo: res.empresa == undefined ? '5ca7ceb45e37fa06227a6ad6' : res.empresa,
      empresaid: 0,
      idMongo: res.id,
      codigovendedor: res.codigoVendedor,
      idsucursal: sucursal.idsucursal == null ? null : sucursal.idsucursal*/

    }
    return data;
  }

}



// WEBPACK FOOTER //
// ./src/pages/ficha-tabs/ficha-medicion/ficha-medicion.ts